import type * as React from 'react';
import { useCallback, useState } from 'react';
import { useFragment } from 'react-relay';
import { useNavigate } from 'react-router-dom';
import { LabeledSelectBox } from '@components/labeledSelectBox';
import { cutOffListFragment } from './CutOffList.relay';
import { CutOffListDownload } from './lib/cutOffListDownload';
import { CutOffTable } from './lib/cutOffTable';
import type { CutOffListPropsType } from './types';

const CutOffList: React.FC<CutOffListPropsType> = ( props ) => {
    const navigate = useNavigate();

    const component = useFragment( cutOffListFragment, props.component );

    const getInitialSalesAdmission = () => {
        let salesAdmission = 'AT';
        if ( props.location.state ) {
            salesAdmission = props.location.state.salesAdmission || salesAdmission;
        }
        return salesAdmission;
    };

    const [ salesAdmission, setSalesAdmission ] = useState( getInitialSalesAdmission );

    const changeSalesAdmission = useCallback(
        ( key: string ) => {
            let locationDescriptor = typeof props.location === 'string' ? { pathname: props.location, state: {} } : props.location;

            locationDescriptor = {
                ...locationDescriptor,
                state: {
                    ...locationDescriptor.state,
                    salesAdmission: key,
                },
            };

            navigate( { pathname: locationDescriptor.pathname }, { replace: true, state: locationDescriptor.state } );
            setSalesAdmission( key );
        },
        [ props.location, navigate ],
    );

    const disclaimer = component.disclaimer;

    return (
        <div className='relative mx-auto flex w-full max-w-[820px] flex-wrap items-start justify-between max-[1100px]:w-[calc(100vw-80px)] max-[1100px]:max-w-[565px] max-[600px]:w-[calc(100vw-40px)]'>
            <div className='w-full'>
                <h2 className='mb-10 w-full text-[40px] leading-[1.1] text-[#668272] max-[600px]:text-[32px] max-[600px]:leading-10'>{component.title}</h2>

                <div className='max-[650px]:mt-[46px]'>
                    <LabeledSelectBox labeledSelectBox={ component.salesAdmission } selected={ salesAdmission } onChange={ changeSalesAdmission } pushUp={ true } />
                </div>
                <CutOffListDownload cutOffListDownload={ component.downloadOverview } salesAdmission={ salesAdmission } className='CutOffTable-download-overall' />
                <CutOffTable introduction={ component.introduction } table={ component.cutOffTable } salesAdmission={ salesAdmission } locationState={ props.location.state } location={ props.location } />

                {disclaimer ? <div className='clear-both leading-[1.3] text-[#686868]'>{disclaimer}</div> : null}
            </div>
        </div>
    );
};

export { CutOffList };
